/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskExperianLien } from './ExecRiskExperianLien';
import {
    ExecRiskExperianLienFromJSON,
    ExecRiskExperianLienFromJSONTyped,
    ExecRiskExperianLienToJSON,
} from './ExecRiskExperianLien';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedExperianLiensResponse
 */
export interface ExecRiskPaginatedExperianLiensResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianLiensResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskExperianLien>}
     * @memberof ExecRiskPaginatedExperianLiensResponse
     */
    results: Array<ExecRiskExperianLien>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedExperianLiensResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianLiensResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianLiensResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedExperianLiensResponse interface.
 */
export function instanceOfExecRiskPaginatedExperianLiensResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedExperianLiensResponseFromJSON(json: any): ExecRiskPaginatedExperianLiensResponse {
    return ExecRiskPaginatedExperianLiensResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedExperianLiensResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedExperianLiensResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskExperianLienFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedExperianLiensResponseToJSON(value?: ExecRiskPaginatedExperianLiensResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskExperianLienToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

